(function () {
  const FILTER_PARAM = "project-categories";

  function getActiveCategories() {
    return (new URLSearchParams(window.location.search).get(FILTER_PARAM) || "")
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean);
  }

  function updateUrl(activeCategories) {
    const url = new URL(window.location.href);

    if (activeCategories.length) {
      url.searchParams.set(FILTER_PARAM, activeCategories.join(","));
    } else {
      url.searchParams.delete(FILTER_PARAM);
    }

    window.history.pushState({}, "", url);
  }

  function updateFilterButtons(activeCategories) {
    document
      .querySelectorAll("[data-project-filter-value]")
      .forEach((button) => {
        const isActive = activeCategories.includes(button.dataset.projectFilterValue);

        button.setAttribute("aria-pressed", String(isActive));
        button.classList.toggle("active", isActive);
      });

    document.querySelectorAll("[data-project-filter-clear]").forEach((button) => {
      button.classList.toggle("hidden", !activeCategories.length);
    });
  }

  function applyProjectCategoryFilters() {
    const activeCategories = getActiveCategories();
    const projectCards = document.querySelectorAll("[data-project-categories]");

    if (!projectCards.length) {
      return;
    }

    if (!activeCategories.length) {
      projectCards.forEach((card) => {
        card.classList.remove("hidden");
      });
      updateFilterButtons(activeCategories);
      return;
    }

    projectCards.forEach((card) => {
      const cardCategories = (card.dataset.projectCategories || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);

      const matches = activeCategories.some((category) =>
        cardCategories.includes(category)
      );

      card.classList.toggle("hidden", !matches);
    });

    updateFilterButtons(activeCategories);
  }

  function toggleProjectCategory(category) {
    const activeCategories = getActiveCategories();
    const nextCategories = activeCategories.includes(category)
      ? activeCategories.filter((item) => item !== category)
      : [...activeCategories, category];

    updateUrl(nextCategories);
    applyProjectCategoryFilters();
  }

  function bindProjectCategoryFilters() {
    document.querySelectorAll("[data-project-filter-value]").forEach((button) => {
      if (button.dataset.projectFilterBound === "true") {
        return;
      }

      button.dataset.projectFilterBound = "true";
      button.addEventListener("click", () => {
        toggleProjectCategory(button.dataset.projectFilterValue);
      });
    });

    document.querySelectorAll("[data-project-filter-clear]").forEach((button) => {
      if (button.dataset.projectFilterBound === "true") {
        return;
      }

      button.dataset.projectFilterBound = "true";
      button.addEventListener("click", () => {
        updateUrl([]);
        applyProjectCategoryFilters();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      bindProjectCategoryFilters();
      applyProjectCategoryFilters();
    });
  } else {
    bindProjectCategoryFilters();
    applyProjectCategoryFilters();
  }

  document.addEventListener("shopify:section:load", () => {
    bindProjectCategoryFilters();
    applyProjectCategoryFilters();
  });
  window.addEventListener("popstate", applyProjectCategoryFilters);
})();
